module.exports = __webpack_public_path__ + "img/fig19.aff773f2.jpg";